// Custom Scripts
import "bootstrap";
import { CookieStorage } from "cookie-storage";
import { Swiper, Navigation, Scrollbar, Autoplay, Pagination } from "swiper";
// Install modules
Swiper.use([Navigation, Scrollbar, Autoplay, Pagination]);
import ScrollMagic from "scrollmagic";
import "animation.gsap";
import "waypoints/lib/noframework.waypoints";
import imagesLoaded from "imagesloaded";
imagesLoaded.makeJQueryPlugin($);
// import parallax from "./jquery.parallax.js";
import scrollOverflow from "./scrolloverflow.min.js";
import fullpage from "fullpage.js";
import Isotope from "isotope-layout";
import InfiniteAjaxScroll from "@webcreate/infinite-ajax-scroll";
require("es6-object-assign").polyfill();
if (!Number.isNan) {
  Object.defineProperty(Number, "isNaN", {
    value: function (value) {
      return value !== value;
    }
  });
}
var hash = window.location.hash.substring(1);
var is_safari =
  navigator.userAgent.indexOf("Safari") > -1 &&
  navigator.vendor.indexOf("Apple") > -1;


$(function () {



  var $navbarToggler = $(".navbar-toggler");

  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  // Accessibility 
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

  let accessibility = {
    jqueryForm7Recaptcha: function (id) {

      // console.log('catch: jqueryForm7Recaptcha: ');
      // console.log('catch: id: ' + id);

      var timesLooked = 0;
      var lookInterval;
      var targetsPresent = $('#' + id).length;

      var applyFix = function (timesLooked) {
        if (noLabelExists(id)) {
          $('#' + id).before('<label class="sr-only" for="' + id + '">Recaptcha textarea</label>');
        }
      }

      var noLabelExists = function (id) {
        var result = $("label[for='" + id + "']").length ? false : true;
        // console.log('result: ' + result);
        return result;
      }

      var lookForTargets = function () {
        timesLooked++;
        targetsPresent = $('#' + id).length;

        if (timesLooked > 10 || targetsPresent > 0) {
          // There can be only one so do test both things at once
          clearInterval(lookInterval);
          applyFix(timesLooked);
        }
      }

      // Immediately fix any
      applyFix();

      // Check for others for a bit
      lookInterval = setInterval(lookForTargets, 500);
    },
    img: function () {
      var targetsPresent = $("img:not([alt])").length;
      var timesLooked = 0;
      var lookInterval;



      var applyFix = function () {

        $("img:not([alt])").attr("aria-hidden", "true").attr("alt", "third party tool");
      }

      var lookForTargets = function () {
        timesLooked++;
        targetsPresent = $("img:not([alt])").length;

        if (timesLooked > 10) {
          clearInterval(lookInterval);
        }
        if (targetsPresent > 0) {
          applyFix();
        }
      }

      // Immediately fix any
      applyFix();

      // Check for others for a bit
      lookInterval = setInterval(lookForTargets, 500);
    },
    noscript: function () {
      $("noscript").attr("aria-hidden", "true").attr("alt", "third party item");
    },
    init: function () {
      accessibility.img();
      accessibility.jqueryForm7Recaptcha('g-recaptcha-response-100000');
      accessibility.jqueryForm7Recaptcha('g-recaptcha-response-100001');
    }
  }



  accessibility.init();


  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  // Waypoints 
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~


  var handleWaypoints = function () {
    if ($(".inview").length) {
      $(".inview").each(function () {
        let delay = $(this).data("offset") ? $(this).data("offset") : "90%";
        let easeType = $(this).data("ease") ? $(this).data("ease") : "fadeInUp";
        let waypoint = new Waypoint({
          element: this,
          handler: function (direction) {
            if (direction == "down" && !$(this.element).hasClass(easeType)) {
              $(this.element).addClass(easeType);
            }
          },
          offset: delay
        });
      });
    }
  };

  handleWaypoints();


  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  // Handle Video CTA
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

  if ($(".video .placeholder").length) {
    $(".video .placeholder .video-btn").on("click", function (evt) {
      evt.preventDefault();
      let $video = $(this).parents(".video");
      $(this)
        .parents(".placeholder")
        .fadeOut(600, function () {
          $video.find("iframe")[0].src += "&autoplay=1";
        });
    });
  }
  if (is_safari == true) {
    $("body").addClass("apple-safari");
  }

  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  // Enable parallax
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

  if ($(".parallax").length) {
    $(".parallax").parallax();
  }

  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  // Handle Location
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

  var locationSet = function (slug) {
    if (slug != "#") {
      history.pushState(slug, null, slug);
    } else {
      history.pushState(null, null, "/recipes/");
    }
  };
  $("header").imagesLoaded(function () {
    $("#main-nav .navbar-brand").addClass("ready");
  });

  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  // Soft scroll
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

  if ($(".anchor").length) {
    $(".anchor").on("click", function (evt) {
      evt.preventDefault();
      let navMenu = $(this).find(".nav-link").length ? true : false;
      let target =
        navMenu == true
          ? $(this)
            .find(".nav-link")
            .attr("href")
          : $(this).attr("href");
      if ($(target).length) {
        evt.preventDefault();
        $("html, body").animate(
          {
            scrollTop: $(target).offset().top - 60
          },
          1000
        );
        if (navMenu == true) $navbarToggler.trigger("click");
      } else {
        window.location = "/" + target;
      }
    });
  }

  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  // Append to Nav Toggle Action
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

  // What are all the focusable item sin the menu
  // What are all the focusable item sin the menu
  var $expandedNavItems = $('#expanded-menu a');

  var triggerCollapseMenu = function () {
    if (!$navbarToggler.hasClass('collapsed')) {
      $navbarToggler.click();
    }
  }

  var navItemsFocusable = function (focusable) {
    if (focusable) {
      $expandedNavItems.removeAttr('tabindex');
    } else {
      $expandedNavItems.attr('tabindex', '-1');
    }
  }

  $navbarToggler.on("click", function () {
    if ($(this).hasClass("collapsed")) {
      $("#main-nav").addClass("reset");
      $(".navbar-brand").addClass("hide");
      $("body").addClass("hide-scroll");
      navItemsFocusable(true);
    } else {
      $("#main-nav").removeClass("reset");
      $(".navbar-brand").removeClass("hide");
      $("body").removeClass("hide-scroll");
      navItemsFocusable(false);
      navItemLastFocused = false;
    }
  });
  $(document).on(
    'keydown', function (event) {
      if (event.key == "Escape") {
        triggerCollapseMenu();
      }
    });

  if (hash.length) {
    if ($("#" + hash).length) {
      $("html, body").animate(
        {
          scrollTop: $("#" + hash).offset().top - 100
        },
        1000
      );
    }
  }



  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  // Handle Nav Focus
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~



  // On page load, make focusable items temporarily non focusable
  navItemsFocusable(false);


  // Identify the last nav item
  var $navItemLast = $expandedNavItems.last();
  var navItemLastFocused = false;
  var tabShift = false;

  // Make note that we're on the last item so that...
  $navItemLast.on("focus", function () {
    navItemLastFocused = true;
  });

  $navbarToggler.on("focus", function () {
    if (tabShift) {
      window.scrollTo(0, 0)
    }
  });

  $(document).on('keydown', function (event) {
    // ...if they tab, it collapses the menu
    if (event.key == "Tab" && navItemLastFocused) {
      triggerCollapseMenu();
    }
    // Did they just press Tab + Shift?
    tabShift = event.key == "Tab" && (event.shiftKey == true) ? true : false;
  });




  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  // Promo Notice Show
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

  if ($("#promo-notification").length) {
    const cookieStorage = new CookieStorage();
    if (cookieStorage.getItem("cookie_promo") === null) {
      $("article.offset-menu").addClass("has-promobar");
      $("#promo-notification").show();
      $("#promo-notification .close").on("click", function (evt) {
        evt.preventDefault();
        // Set Cookie
        cookieStorage.setItem("cookie_promo", 1, {
          path: "/"
        });
        $("article.offset-menu").removeClass("has-promobar");
        $("#promo-notification").hide();
      });
    } else {
      $("article.offset-menu").removeClass("has-promobar");
      $("#promo-notification").remove();
    }
  }

  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  // Scroll Nav on Auto Hide
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

  var navBarHt = $("#main-nav").outerHeight() + 50;
  var prevScrollpos = window.pageYOffset;
  var promoBar =
    $("#promo-notification").length && $("#promo-notification").is(":visible")
      ? $("#promo-notification").outerHeight()
      : 0;
  $(window)
    .scroll(function () {
      let currentScrollPos = window.pageYOffset;
      if (currentScrollPos > navBarHt + 25) {
        $("#main-nav").addClass("scrolled");
        if ($(".alt-menu").length) {
          $(".alt-menu")
            .find("img:first")
            .removeClass("d-none"); // color
          $(".alt-menu")
            .find("img:last")
            .addClass("d-none"); //White
        }
      } else {
        $("#main-nav").removeClass("scrolled");
        if ($(".alt-menu").length) {
          $(".alt-menu")
            .find("img")
            .addClass("d-none");
          $(".alt-menu")
            .find("img.default")
            .removeClass("d-none");
        }
      }
      if (
        prevScrollpos > currentScrollPos ||
        currentScrollPos == 0 ||
        currentScrollPos < navBarHt
      ) {
        $("#main-nav").css({
          top: 0
        });
      } else {
        $("#main-nav").css({
          top: "-" + navBarHt + "px"
        });
      }
      prevScrollpos = currentScrollPos;
    })
    .trigger("scroll");

  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  // Cookie Notice SHow
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

  if ($("#cookie-notification").length) {
    const cookieStorage = new CookieStorage();
    if (cookieStorage.getItem("cookie_policy") === null) {
      $("#cookie-notification").show();
      $("#cookie-notification .link").on("click", function (evt) {
        evt.preventDefault();
        let policy = $(this).hasClass("agree") ? "yes" : "no";
        // Set Cookie
        cookieStorage.setItem("cookie_policy", policy, {
          path: "/"
        });
        $("#cookie-notification").hide();
        if (
          !$("#footer-section .fp-scrollable").length &&
          !$("#footer-lower .fp-scrollable").length
        ) {
          $("#cookie-gap").remove();
        }
      });
    } else {
      $("#cookie-notification").remove();
      if (
        !$("#footer-section .fp-scrollable").length &&
        !$("#footer-lower .fp-scrollable").length
      ) {
        $("#cookie-gap").remove();
      }
    }
  }

  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  // Init Home
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

  if ($("#home").length) {
    if ($("#home-main-swiper").length) {
      var swiperMainHome = new Swiper("#home-main-swiper", {
        slidesPerView: 1,
        speed: 600,
        loop: false,
        noSwiping: true,
        allowSlidePrev: false,
        allowSlideNext: false,
        keyboard: true,
        // autoplay: {
        //   delay: 3000,
        //   enabled: true
        //},
        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true
        // },
        on: {
          init: triggerAnime,
          slideChangeTransitionEnd: triggerAnime
        }
      });
    }
    function triggerAnime(swiper) {
      let $current = $("#home-main-swiper .swiper-slide .animate");
      $current.removeClass("fadeInDown");
      $("#home-main-swiper .swiper-slide-active .animate").addClass(
        "fadeInDown"
      );
    }
    var randomInteger = function (min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    };
    var switchLogoMenu = function (color, $logoW, $logo, $navbarToggler) {
      if (color == "white") {
        $logoW.removeClass("d-none");
        $logo.addClass("d-none");
        $navbarToggler
          .addClass("set-white")
          .removeClass("d-none")
          .removeClass("menu-color");
      } else if (color == "color") {
        $logoW.addClass("d-none");
        $logo.removeClass("d-none");
        $navbarToggler
          .removeClass("set-white")
          .removeClass("d-none")
          .addClass("menu-color");
      } else {
        // Remove
        $logoW.addClass("d-none");
        $logo.addClass("d-none");
        $navbarToggler
          .addClass("d-none")
          .removeClass("set-white")
          .removeClass("menu-color");
      }
    };
    if ($(".scroll-item.section-video").length) {
      let _total = $(".scroll-item.section-video").data("total");
      let random = _total > 0 ? randomInteger(0, _total) : 0;
      if ($(".swap-bkg").data("image" + random).length) {
        $(".swap-bkg").css(
          "background-image",
          "url(" + $(".swap-bkg").data("image" + random) + ")"
        );
        $(".swap-title").prop("src", $(".swap-title").data("image" + random));
        $(".swap-video").prop("src", $(".swap-video").data("video" + random));
        $(".swap-cta").text($(".swap-cta").data("cta" + random));
      }
    }


    var scrollSections = []
    $('.scroll-item').each(
      function () {
        var sectionId = $(this).attr('id');
        scrollSections.push(sectionId.slice(1));
      }
    );
    // Full Page Scrolling
    // Trigger First Element Background For Group
    $("#background-scroll .chevron-hero")
      .first()
      .addClass("active");

    new fullpage("#home", {
      sectionSelector: ".vertical-scrolling",
      anchors: scrollSections,
      keyboardScrolling: true,
      animateAnchor: true,
      recordHistory: true,
      a11y: {
        enabled: true,
        containerMessage: 'This contains a group of slides showing related products',
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
      },
      navigation: true,
      navigationPosition: "right",
      slidesNavigation: false,
      autoScrolling: false,
      controlArrows: true,
      scrollingSpeed: 800,
      touchSensitivity: 10,
      scrollOverflow: true,
      licenseKey: "7D643BE9-3ED54E96-9D5014D8-1831DEDE",
      afterRender: function () {
        fullpage_api.silentMoveTo(1);
        fullpage_api.setAutoScrolling(true);
        $("#fp-nav").attr('role', 'navigation');
        $("#fp-nav a").attr('role', 'button');
        $("#fp-nav .fp-sr-only + span").attr('role', 'presentation').attr('aria-hidden', 'true');
      },
      onLeave: function (origin, destination, direction) {
        let $elm = $("#background-scroll .chevron-hero");
        let $logoW = $("#main-nav .alt-menu img.default");
        let $navbarToggler = $("#main-nav .navbar-toggler");
        let $logo = $("#main-nav .alt-menu img").not(".default");
        let $fpNav = $("#fp-nav");
        let hasVideo = $(".section-video").length ? 1 : 0;
        if (destination.index == 0) {
          switchLogoMenu("color", $logo, $logoW, $navbarToggler);
          $fpNav.removeClass("d-none");
          /*
        } else if (destination.index == $elm.length) {
          switchLogoMenu("none", $logoW, $logo, $navbarToggler);
          $fpNav.addClass("d-none");
          */
        } else {
          switchLogoMenu("white", $logo, $logoW, $navbarToggler);
          $fpNav.removeClass("d-none");
        }
        $elm.removeClass("active");
        $elm.eq(destination.index).addClass("active");
      }
    });
    if ($(".section-video").length) {
      $(".section-video .play-btn").on("click", function (e) {
        e.preventDefault();
        $(".video-placeholder").addClass("disable");
        $("iframe").addClass("active");
        return false;
      });
    }
    $(window).on("load", function () {
      setTimeout(function () {
        window.scrollTo(0, 0);
      }, 1);
    });


    $('.trigger-next-slide').on("click", function (e) {
      e.preventDefault;
      var thisSlide = $(this).parents('.scroll-item');

      // Get the number of this slide in the list of slides
      var index = $('.scroll-item').index(thisSlide);
      fullpage_api.moveSectionDown(index + 1);
    });


  }

  var $body = $('body');
  $(document).on('keydown', function (event) {
    if (event.key == "Tab" || event.key == "ArrowUp" || event.key == "ArrowRight" || event.key == "ArrowDown" || event.key == "ArrowLeft") {
      $body.addClass('show-accessibility-tip');
    }
  });

  var makeTabbable = function (tabbable, parent) {
    var $targets = $(parent).find(".tabbable-item");
    if ($targets.length) {
      var tabindex = tabbable ? '0' : '-1';
      $targets.attr('tabindex', tabindex);
    }
  }





  var $filterDropdown = $('#products-filter .filter-item');
  var $filterDropdownTrigger = $('#products-filter .filter-selected');
  var $filterClear = $("#products-filter #clear");

  var filterDropdownOpen = function () {
    $filterDropdown.addClass("active");
    $filterClear.trigger("click").removeClass("fade");
  }

  var filterDropdownClose = function () {
    $filterDropdown.removeClass("active");
    $filterClear.addClass("fadeIn");
  }

  if ($("#products-filter").length) {

    $(".filter-selected").on("click", function () {
      if ($filterDropdown.hasClass("active")) {
        filterDropdownClose();
      } else {
        filterDropdownOpen();
      }
    });

    $(document).on('keydown', function (event) {
      if (event.key == "Escape") {
        if ($filterDropdown.hasClass("active")) {
          filterDropdownClose();
        }
      }
    });
  }

  if ($("#product-page").length) {


    // Product Size dropdown
    $(".filter-selected").on("click", function () {
      if (
        !$(this)
          .parent()
          .hasClass("active")
      ) {
        $(".filter-item").removeClass("active");
        $(this)
          .parent()
          .addClass("active");
      } else {
        $(this)
          .parent()
          .removeClass("active");
      }
    });

    // Product Size dropdown item
    $(".selector-filter  > .item").on("click", function () {

      let _index = $(this).data("filter");
      if (("#nutrition-" + _index).length) {
        $(".nutrition-facts-wrapper").removeClass("show");
        $("#nutrition-" + _index).addClass("show");
      }
      if (("#ingredients-" + _index).length) {
        $(".ingredients-facts-wrapper").removeClass("show");
        $("#ingredients-" + _index).addClass("show");
      }
      if (("#contains-" + _index).length) {
        $(".contains-facts-wrapper").removeClass("show");
        $("#contains-" + _index).addClass("show");
      }
      let txt = $(this).parents(".selector-filter")
        .find(".filter-all")
        .text();
      $(this)
        .parents(".filter-item")
        .removeClass("active");
      $(this)
        .parents(".filter-item")
        .find(".filter-selected")
        .focus()
        .text($(this).text());



    });
    if ($(".related-wrapper").length) {
      var swiperRelated = new Swiper(".related-wrapper .swiper-container", {
        slidesPerView: 3,
        a11y: {
          enabled: true,
          containerMessage: 'This contains a group of slides showing related products',
          prevSlideMessage: 'Previous slide',
          nextSlideMessage: 'Next slide',
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        breakpoints: {
          320: {
            slidesPerView: 1
          },
          580: {
            slidesPerView: 2
          },
          1024: {
            slidesPerView: 3
          }
        }
      });
    }
  }



  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  // Init Product Layout
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

  var $tabbableSimulateClick = $('.tabbable-simulate-click');
  $(document).on('keydown', function (event) {
    if (event.key == "Enter") {
      // Trigger a focused checkbox to toggle when someone preses "enter" 
      $tabbableSimulateClick.each(function (index) {
        var hasFocus = $(this).is(":focus");
        if (hasFocus) {
          $(this).trigger("click");
          return false;
        }
      });
    }
  });



  if ($("#products").length) {
    var $containerProduct = $("#products");
    var $filterContainer = $('#expand-filter');
    var filterStr = "";

    var productInputsTabbable = function (tabbable) {
      var $targets = $("#products-filter .tabbable-item");
      if ($targets.length) {
        var tabindex = tabbable ? '0' : '-1';
        $targets.attr('tabindex', tabindex);
      }
    }





    $filterContainer.on('show.bs.collapse', function () {
      productInputsTabbable(true);
      filterDropdownOpen();
    });

    $filterContainer.on('hide.bs.collapse', function () {
      productInputsTabbable(false);
      filterDropdownClose();
    });

    $(document).on('keydown', function (event) {
      if (event.key == "Escape") {
        triggerCollapseMenu();
        // filterDropdownClose();
        if ($filterContainer.hasClass('show')) {
          $filterDropdownTrigger.trigger('click');
          $filterDropdown.focus();
        }
      }
    });

    productInputsTabbable(false);


    $containerProduct.imagesLoaded(function () {
      if ($("#products-listing-cans").length) {
        var $cansGrid = new Isotope("#products-listing-cans", {
          itemSelector: ".grid-item",
          layoutMode: "fitRows",
          transitionDuration: 0
        });
      }
      if ($("#products-listing-pouches").length) {
        var $pouchesGrid = new Isotope("#products-listing-pouches", {
          itemSelector: ".grid-item",
          layoutMode: "fitRows",
          transitionDuration: 0
        });
      }
      if ($("#products-listing-kits").length) {
        var $kitsGrid = new Isotope("#products-listing-kits", {
          itemSelector: ".grid-item",
          layoutMode: "fitRows",
          transitionDuration: 0
        });
      }
      if ($("#products-listing-other").length) {
        var $otherGrid = new Isotope("#products-listing-other", {
          itemSelector: ".grid-item",
          layoutMode: "fitRows",
          transitionDuration: 0
        });
      }
      var arrangeGrid = function ($objGrid, selector, element) {
        if ($($objGrid).length) {
          $objGrid.arrange({
            filter: selector
          });
          $objGrid.on("arrangeComplete", function () {
            $(".products-listing .grid-item")
              .not(":visible")
              .removeClass("active");
            $(".products-listing .grid-item:visible").addClass("active");
            if (element) {
              $(element)
                .find("h2 span")
                .text($objGrid.filteredItems.length);
            }
          });
        }
      };
      $("#clear").on("click", function (e) {
        e.preventDefault();
        $("#product-filter-options")[0].reset();
        filterStr = "*";
        arrangeGrid($cansGrid, filterStr, "#cans-section");
        arrangeGrid($pouchesGrid, filterStr, "#pouches-section");
        arrangeGrid($kitsGrid, filterStr, "#kits-section");
        arrangeGrid($otherGrid, filterStr, "#other-section");
        return false;
      });

      function getComboFilter(filters) {
        var combo = [];
        for (var prop in filters) {
          var group = filters[prop];
          if (!group.length) {
            // no filters in group, carry on
            continue;
          }
          // add first group
          if (!combo.length) {
            combo = group.slice(0);
            continue;
          }
          // add additional groups
          var nextCombo = [];
          // split group into combo: [ A, B ] & [ 1, 2 ] => [ A1, A2, B1, B2 ]
          for (var i = 0; i < combo.length; i++) {
            for (var j = 0; j < group.length; j++) {
              var item = combo[i] + group[j];
              nextCombo.push(item);
            }
          }
          combo = nextCombo;
        }
        var comboFilter = combo.join(", ");
        return comboFilter;
      }
      $("#products-filter .form-check-input").on("change", function () {
        var filters = {};
        $("#products-filter .form-check-input:checkbox:checked").each(
          function () {
            let group = $(this)
              .parents(".filter")
              .data("group");
            if (!filters[group]) {
              filters[group] = [];
            }
            filters[group].push($(this).val());
          }
        );
        //console.log(filters)
        var filtersVal = getComboFilter(filters);
        // console.log(filtersVal)
        filterStr = filtersVal.length ? filtersVal : "*";
        arrangeGrid($cansGrid, filterStr, "#cans-section");
        arrangeGrid($pouchesGrid, filterStr, "#pouches-section");
        arrangeGrid($kitsGrid, filterStr, "#kits-section");
        arrangeGrid($otherGrid, filterStr, "#other-section");
      });
      $("#products").imagesLoaded(function () {
        $(".products-listing .grid-item")
          .not(":visible")
          .removeClass("active");
        $(".products-listing .grid-item:visible").addClass("active");
      });

      // Handle Sub Page
      if ($("#products").data("default").length) {
        let filterTarget = $("#products").data("default");
        if ($("#filter-" + filterTarget).length) {
          let $targ = $("#" + filterTarget + "-section").length
            ? $("#" + filterTarget + "-section")
            : $("#products-filter");
          $("#filter-" + filterTarget)
            .prop("checked", true)
            .trigger("change");
          $("html, body").animate(
            {
              scrollTop: $targ.offset().top - 60
            },
            800
          );
        }
      }

    });
  }

  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  // Init About
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

  if ($("#about").length) {

    // Full page
    // new fullpage("#about", {
    //   sectionSelector: ".vertical-scrolling",
    //   slidesNavigation: false,
    //   autoScrolling: false,
    //   scrollingSpeed: 800,
    //   touchSensitivity: 10,
    //   scrollOverflow: true,
    //   licenseKey: "7D643BE9-3ED54E96-9D5014D8-1831DEDE",
    //   afterRender: function () {
    //     fullpage_api.silentMoveTo(1);
    //     fullpage_api.setAutoScrolling(true);
    //   },
    //   onLeave: function (origin, destination, direction) {
    //     let $elm = $(".vertical-scrolling");
    //     let $logoW = $("#main-nav .alt-menu img.default");
    //     let $navbarToggler = $("#main-nav .navbar-toggler");
    //     let $logo = $("#main-nav .alt-menu img").not(".default");
    //     $logoW.addClass("d-none");
    //     $logo.addClass("d-none");
    //     $navbarToggler.addClass("d-none");
    //     if (destination.index == $elm.length - 1) {
    //       $("#banner-section").addClass("fadeIn");
    //     } else if (destination.index == 0) {
    //       $logoW.removeClass("d-none");
    //       $navbarToggler.removeClass("d-none");
    //     }
    //   }
    // });
    // $(window).on("load", function () {
    //   setTimeout(function () {
    //     window.scrollTo(0, 0);
    //   }, 1);
    // });

    // Horizontal scoll
    var swiper = new Swiper(".swiper-container", {
      slidesPerView: 2.5,
      spaceBetween: 40,
      a11y: {
        enabled: true,
        containerMessage: 'This contains a group of slides showing Bumblebee history',
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true
      },
      keyboard: {
        enabled: true,
        onlyInViewport: false,
      },
      breakpoints: {
        320: {
          slidesPerView: 1.2
        },
        580: {
          slidesPerView: 2.5
        }
      }
    });

    // Make the "WANT TO DIVE DEEPER" background animate once scroll into view
    var $bannerSection = $('#banner-section');
    var elementScrolled = function (elem) {
      var docViewTop = $(window).scrollTop();
      var docViewBottom = docViewTop + $(window).height();
      var elemTop = $(elem).offset().top;
      return ((elemTop <= docViewBottom) && (elemTop >= docViewTop));
    }

    $(window).scroll(function () {
      if (!$bannerSection.hasClass('fadeIn')) {
        if (elementScrolled('#banner-section')) {
          $bannerSection.addClass('fadeIn')
        }
      }
    });

    $bannerSection.removeClass('fadeIn');











  }
  if ($("#recipes").length) {
    var swiper = new Swiper(".swiper-container", {
      slidesPerView: 4.5,
      spaceBetween: 30,
      loop: false,
      breakpoints: {
        320: {
          slidesPerView: 1.2
        },
        580: {
          slidesPerView: 2.5
        },
        1199: {
          slidesPerView: 3.5
        },
        1799: {
          slidesPerView: 4.5
        }
      }
    });
    var debounced = function (fn, threshold) {
      var timeout;
      threshold = threshold || 100;
      return function debounced() {
        clearTimeout(timeout);
        var args = arguments;
        var _this = this;

        function delayed() {
          fn.apply(_this, args);
        }
        timeout = setTimeout(delayed, threshold);
      };
    };
    $("#live-search").on(
      "keyup",
      debounced(function () {
        $("#searchResult")
          .removeClass("product")
          .addClass("recipe");
        var $search = $(this)
          .val()
          .toLowerCase()
          .replace(/[^a-z0-9\s\+]+/g, "");
        if ($search != "" && $search.length > 2) {
          $.ajax({
            type: "POST",
            url: "/wp-admin/admin-ajax.php",
            dataType: "json",
            data: {
              action: "live-search",
              search: $search
            },
            success: function (response) {
              let len = response.length;
              $("#searchResult")
                .removeClass("fadeInUp")
                .empty();
              for (var i = 0; i < len; i++) {
                var name = response[i]["name"];
                var link = response[i]["link"];
                $("#searchResult").append(
                  '<a href="' + link + '">' + name + "</a>"
                );
              }
              $("#searchResult").addClass("fade fadeInUp");
            }
          });
        } else {
          $("#searchResult")
            .removeClass("fadeInUp")
            .empty();
        }
      }, 200)
    );
    var iasRecipe;
    var ajaxRecipeFilter = function (type) {
      if (iasRecipe) iasRecipe.disableLoadOnScroll();
      iasRecipe = new InfiniteAjaxScroll(".grid-layout.infinite", {
        logger: false,
        item: ".grid-item",
        next: function (index) {
          return recipeGridItem(index, ".grid-layout", type);
        },
        pagination: false
      });

      function recipeGridItem(pageIndex, elm, type) {
        return fetch(
          "/wp-admin/admin-ajax.php?action=load-recipes&category=" +
          type +
          "&page=" +
          (pageIndex + 1)
        )
          .then(response => response.json())
          .then(data => {
            let itemsPerPage = 6;
            let totalPages = Math.ceil(data["total"] / itemsPerPage);
            for (let i = 0; i < data["entry"].length; i++) {
              let itemData = data["entry"][i];
              if (itemData) {
                let item = createReceipeItem(itemData);
                $("#category " + elm).append(item);
              }
            }
            let hasNextPage = pageIndex + 1 != totalPages;
            return hasNextPage;
          })
          .catch(function (error) {
            //console.log(error);
          });
      }
    };
    var createReceipeItem = function (data) {
      const template = `<div class="grid-item col-md-6 col-lg-4 col-xl-3 mb-4"><div class="card h-100">
        <a href="${data.link}" class="zoom card-img-top"><img class="img-fluid zoom-image" src="${data.image}" alt="${data.name}"></a>
        <div class="card-body">
          <h3 class="h6 exbold blue">${data.category}</h3>
          <h4 class="h4 card-title red">${data.name}</h4>
        </div><div class="card-footer"><a href="${data.link}" class="read-more">Read More</a></div></div>
      </div>`;
      let item = document.createElement("div");
      item.innerHTML = template.trim();
      return item.firstChild;
    };
    var initClickProductRecipe = function () {
      $("#searchResult a").on("click", function (event) {
        if ($("#searchResult").hasClass("product")) {
          event.preventDefault();
          $("#live-search-product").val($(this).text());
          var recipeId = $(this).data("ref");
          $.ajax({
            type: "POST",
            url: "/wp-admin/admin-ajax.php",
            dataType: "json",
            data: {
              action: "get-recipe-product",
              rid: recipeId
            },
            success: function (response) {
              if (response) {
                window.location.hash = "#" + recipeId;
                $(".sectional")
                  .removeClass("active")
                  .fadeOut(300, function () {
                    $("#category .grid-layout").empty();
                    $("#by-product .grid-layout").empty();
                    $(".search-by-product .error-box").hide();
                    if (iasRecipe) iasRecipe.disableLoadOnScroll();
                    $("#recipe-options .item-link a").removeClass("active");
                    $("#by-product")
                      .addClass("active")
                      .show();
                    for (let i = 0; i < response["entry"].length; i++) {
                      let itemData = response["entry"][i];
                      if (itemData) {
                        let item = createReceipeItem(itemData);
                        $("#by-product")
                          .find(".grid-layout")
                          .append(item);
                      }
                    }
                  });
              } else {
              }
            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
              $(".search-by-product .error-box").show();
              $("#by-product .grid-layout").empty();
            }
          });
          return false;
        }
      });
    };
    $("#live-search-product").on(
      "keyup",
      debounced(function () {
        $("#searchResult")
          .removeClass("recipe")
          .addClass("product");
        var $search = $(this)
          .val()
          .toLowerCase()
          .replace(/[^a-z0-9\s\+]+/g, "");
        if ($search != "" && $search.length > 2) {
          $("#search-addon-product .fa-spin").show();
          $.ajax({
            type: "POST",
            url: "/wp-admin/admin-ajax.php",
            dataType: "json",
            data: {
              action: "live-search-product",
              search: $search
            },
            success: function (response) {
              let len = response.length;
              $("#searchResult")
                .removeClass("fadeInUp")
                .empty();
              for (var i = 0; i < len; i++) {
                var name = response[i]["name"];
                var rid = response[i]["id"];
                $("#searchResult").append(
                  '<a href="#" data-ref="' + rid + '"> role="button"' + name + "</a>"
                );
              }
              $("#searchResult").addClass("fade fadeInUp");
              initClickProductRecipe();
              $("#search-addon-product .fa-spin").hide();
            }
          });
        } else {
          $("#searchResult")
            .removeClass("fadeInUp")
            .empty();
        }
      }, 200)
    );
    $("#search-addon, #search-addon-product").on("click", function (event) {
      event.preventDefault();
      if ($("#searchResult a:first").length) {
        $("#searchResult a:first")[0].click();
      }
      return false;
    });
    $("#live-search, #live-search-product").on("focus", function () {
      $("#live-search, #live-search-product").val("");
      $("#searchResult")
        .removeClass("fadeInUp")
        .empty();
    });
    var tmSearch = 0;
    $("#live-search-form").on("focusout", function (e) {
      clearTimeout(tmSearch);
      tmSearch = setTimeout(function () {
        $("#live-search").val("");
        $("#searchResult")
          .removeClass("fadeInUp")
          .empty();
      }, 500);
    });
    // Handle Back forward Hostory
    $(window).on("popstate", function (event) {
      if (window.event.state != null) {
        let split = window.event.state.split("/");
        if (split[2]) {
          let clean = split[2].replace("-recipes", "");
          if ($('a[data-slug="' + clean + '"]').length) {
            $('a[data-slug="' + clean + '"]').trigger("click");
          }
        }
      }
    });
    $(".recipe-listing .item-target").on("click", function (e) {
      e.preventDefault();
      let _tar = $(this).data("target");
      $("html, body").animate(
        {
          scrollTop: $("#recipe-menu").offset().top - 140
        },
        1000
      );
      history.pushState(_tar + "-recipes", null, _tar + "-recipes");
      $('.item-link a[data-slug="' + _tar + '"]').trigger("click");
      return false;
    });
    $(".filter-headline").on("click", function () {
      var $parent = recipe.filterNavGetParent($(this));
      var $navLink = $parent.find('.link');
      recipe.filterDropdownClose($navLink);
      // $(this)
      //   .parent()
      //   .removeClass("fadeIn")
      //   .prev()
      //   .removeClass("active");
    });

    $(document).on(
      'keydown', function (event) {
        if (event.key == "Escape") {
          recipe.filterNavReset();
        } else if (event.key == "Tab" && event.shiftKey == true) {
          // If shift-tabbed to another menu item, close any previous dropdowns
          var $target = $(event.target);
          if ($target.hasClass('dropmenu-main') && $target.hasClass('active')) {
            recipe.filterNavReset();
          }
        }
      });

    var recipe = {
      searchReset: function () {
        $("#live-search, #live-search-product").val("");
        $(".search-by-product .error-box").hide();
      },
      filterNavReset: function () {
        $(".link").removeClass("active");
        $(".child-link").removeClass("active");
        $(".dropmenu").removeClass("fadeIn");
        makeTabbable(false, $(".dropmenu"));
      },
      filterNavGetParent: function (navLink) {
        return $(navLink).parents('.item-link');
      },
      filterNavGetDropdown: function (parent) {
        return $(parent).find(".dropmenu");
      },
      filterNavGetDropdownLabel: function (dropdown) {
        return $(dropdown).find(".filter-headline > span");
      },
      filterNavHasDropdown: function (navLink) {
        var returnValue = $(navLink).hasClass('dropmenu-main') ? true : false;
        return returnValue;
      },
      filterNavActivate: function (navLink) {
        let $target = $(navLink);
        let $parent = recipe.filterNavGetParent($target);
        let $dropdown = recipe.filterNavGetDropdown($parent);
        let $dropdownLabel = recipe.filterNavGetDropdownLabel($dropdown);

        let location = $target.attr("href");
        let target = $target.data("target");
        let cleanTitle = $target.text();
        let title = $target.data("slug");


        $target.addClass("active");
        if ($dropdown.length) {
          recipe.filterDropdownOpen($dropdown);
          $dropdownLabel.text(cleanTitle);
        }
      },
      filterDropdownOpen: function (navLink) {
        let $parent = recipe.filterNavGetParent($(navLink));
        let $dropdown = recipe.filterNavGetDropdown($parent);
        $(navLink).addClass('active');
        $dropdown.addClass("fadeIn");
        makeTabbable(true, $dropdown);
      },
      filterDropdownClose: function (navLink) {
        let $parent = recipe.filterNavGetParent($(navLink));
        let $dropdown = recipe.filterNavGetDropdown($parent);
        $(navLink).removeClass('active');
        $dropdown.removeClass("fadeIn");
        makeTabbable(false, $dropdown);
      },
      filterResultsReset: function () {
        $("#by-product")
          .removeClass("active")
          .find(".grid-layout")
          .empty();

      }
    }






    $(".tabbable-item").on("focus", function (e) {
      $(this).addClass('has-focus');
    }).on("focusout", function (e) {
      $(this).removeClass('has-focus');
    });

    $(".dropmenu .tabbable-item").on("focusout", function (e) {
      // If none other in this menu are focused, they tabbed away. Reset all navs
      var $dropdown = $(this).parents(".dropmenu");
      setTimeout(function () {
        var tabbaleCount = $dropdown.find(".tabbable-item.has-focus").length;
        if (tabbaleCount < 1) {
          recipe.filterNavReset();
        }
      }, 100);
    });



    $(".link").on("click", function (e) {
      e.preventDefault();
      var $navLink = $(e.target);

      if (recipe.filterNavHasDropdown($navLink)) {

        if ($navLink.hasClass("active")) {
          // This will never happen with a click because the sub menu covers it.
          // Instead, it's "Enter" key
          recipe.filterDropdownClose($navLink);

        } else {
          // Not active
          // Reset from previous times
          recipe.filterResultsReset();
          recipe.filterNavReset();
          recipe.searchReset();

          // Activate
          recipe.filterNavActivate($(this));
        }

      } else {
        // console.log('XXX: Has no dropdown. Who cares if its active?');
      }




    });

    $(".link").on("click", function (e) {
      e.preventDefault();


      if (!$(this).hasClass("active") || recipe.filterNavHasDropdown($(this))) {
        let location = $(this).attr("href");
        let target = $(this).data("target");
        let cleanTitle = $(this).text();
        let title = $(this).data("slug");

        if (!$(this).parent().find(".dropmenu").length) {

          if (e.which == 1) {
            // e.which == 1 means "left" mous button was clicked
            locationSet(location);
          }

          // "ALL" was chosen
          if (target == "all") {

            // #Reset filtered results and make "all" activated
            $("#category")
              .removeClass("active")
              .fadeOut(300, function () {
                $("#category .grid-layout").empty();
                $("#all").fadeIn(300, function () {
                  $(this).addClass("active");
                });
              });
          } else {

            // If there are NO filtered results
            if (!$("#category").hasClass("active")) {

              // If there are already some filtered results
              $("#all")
                .removeClass("active")
                .fadeOut(300, function () {
                  $("#category .category-title").text(title);
                  $("#category .grid-layout").empty();
                  ajaxRecipeFilter(title);
                  $("#category").fadeIn(300, function () {
                    $(this).addClass("active");
                  });
                });
            } else {

              // Change filtered results by fading out then fading back in
              $("#category")
                .removeClass("active")
                .fadeOut(300, function () {
                  $("#category .category-title").text(title);
                  $("#category .grid-layout").empty();
                  ajaxRecipeFilter(title);
                  $("#category").fadeIn(300, function () {
                    $(this).addClass("active");
                  });
                });
            }
          }
        }
      }
      return false;
    });
    // Child CLick
    $(".child-link").on("click", function (e) {
      e.preventDefault();
      if (!$(this).hasClass("active")) {
        let title = $(this).data("slug");
        let location = $(this).attr("href");
        if (e.which == 1) {
          locationSet(location);
        }
        $(".child-link").removeClass("active");
        $(".link").removeClass("active");
        // $(".dropmenu").removeClass("fadeIn");
        recipe.filterNavReset();
        $(this).addClass("active");
        $(this)
          .parents(".item-link")
          .find(".link")
          .addClass("active");
        if (!$("#category").hasClass("active")) {
          $("#all")
            .removeClass("active")
            .fadeOut(300, function () {
              $("#category .category-title").text(title);
              $("#category .grid-layout").empty();
              ajaxRecipeFilter(title);
              $("#category").fadeIn(300, function () {
                $(this).addClass("active");
              });
            });
        } else {
          $("#category")
            .removeClass("active")
            .fadeOut(300, function () {
              $("#category .category-title").text(title);
              $("#category .grid-layout").empty();
              ajaxRecipeFilter(title);
              $("#category").fadeIn(300, function () {
                $(this).addClass("active");
              });
            });
        }
      }
      return false;
    });

    // Click first Filter
    var allowRecipeType = ["tuna", "clams", "salmon", "sardines"];
    if (!hash) {
      if ($("#recipes").data("default")) {
        let filterTarget = $("#recipes").data("default");
        if (allowRecipeType.includes(filterTarget)) {
          $("#all")
            .removeClass("active")
            .hide();
          $("#category .category-title").text(filterTarget);
          $("#category .grid-layout").empty();
          ajaxRecipeFilter(filterTarget);
          $("#category").fadeIn(400, function () {
            $("html, body").animate(
              {
                scrollTop: $("#recipes").offset().top - 60
              },
              400
            );
          });
        } else {
          if ($(".item-link.filter-" + filterTarget).length) {
            $(".item-link.filter-" + filterTarget + " .link").trigger("click");
          } else if ($(".child-link.filter-" + filterTarget).length) {
            $(".child-link.filter-" + filterTarget).trigger("click");
          } else {
            $(".item-link:first .link").trigger("click");
          }
        }
      } else {
        $(".item-link:first .link").trigger("click");
      }
    } else {
      $.ajax({
        type: "POST",
        url: "/wp-admin/admin-ajax.php",
        dataType: "json",
        data: {
          action: "get-recipe-product",
          rid: hash
        },
        success: function (response) {
          $(".sectional")
            .removeClass("active")
            .fadeOut(300, function () {
              $("#category .grid-layout").empty();
              $("#by-product .grid-layout").empty();
              if (iasRecipe) iasRecipe.disableLoadOnScroll();
              $("#recipe-options .item-link a").removeClass("active");
              $("#by-product")
                .addClass("active")
                .show();
              for (let i = 0; i < response["entry"].length; i++) {
                let itemData = response["entry"][i];
                if (itemData) {
                  let item = createReceipeItem(itemData);
                  $("#by-product")
                    .find(".grid-layout")
                    .append(item);
                }
              }
            });
        }
      });
    }
  }
  if ($("#recipes-template").length) {
    if ($(".recipe-voting").length) {
      $(".recipe-voting").on("click", function (e) {
        e.preventDefault();
        let votes = $(this).hasClass("active") ? 0 : 1;
        let postId = $(this).data("postid");
        $.ajax({
          type: "POST",
          url: "/wp-admin/admin-ajax.php",
          dataType: "json",
          data: {
            action: "recipelikes",
            postId: postId,
            vote: votes
          },
          success: function (response) {
            if (votes) {
              $(".recipe-voting").addClass("active");
            } else {
              $(".recipe-voting").removeClass("active");
            }
          }
        });
        return false;
      });
    }
    var swiper = new Swiper(".swiper-container", {
      slidesPerView: 3,
      spaceBetween: 30,
      breakpoints: {
        320: {
          slidesPerView: 1.3
        },
        600: {
          slidesPerView: 2.3
        },
        992: {
          centeredSlides: false,
          slidesPerView: 3,
          loop: false
        }
      }
    });
    $("#copy-link").on("click", function (e) {
      e.preventDefault();
      var copyUrl = window.location.href;
      $("#copied-url")
        .val(copyUrl)
        .focus()
        .select();
      $("#copied-url")[0].setSelectionRange(0, 99999);
      document.execCommand("copy");
      $("#copied").text("Link is copied to your clipboard.");
      return false;
    });
  }
  if ($(".enable-modal").length) {
    $(".enable-modal").on("click", function (evt) {
      evt.preventDefault();
      let target = $(this).data("target");
      let size = $(this).data("size");

      $(target).find('.close').attr('tabindex', '0');

      if ($(target).length) {
        if (size)
          $("#modal")
            .find(".modal-dialog")
            .addClass(size);
        else
          $("#modal")
            .find(".modal-dialog")
            .addClass("modal-lg");
        $("#modal .modal-body").html($(target).html());
        $("#modal").modal("show");
      }
    });
  }

  $('.modal').on('hide.bs.modal', function (e) {
    $(this).find('.close').attr('tabindex', '-1');
  })

  $('.modal').on('show.bs.modal', function (e) {
    $(this).find('.close').attr('tabindex', '0');
  })

  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  // Scroll Handler
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

  if ($("#arrow-cta").length) {
    var scrollHeightTop = 900;
    var lastY = 0;
    $("#arrow-cta").on("click", function (e) {
      e.preventDefault();
      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: $("main").offset().top - 60
          },
          100
        );
      return false;
    });
    var ctaTimer = 0;
    $(window).scroll(function () {
      if ($("#arrow-cta").length) {
        clearTimeout(ctaTimer);
        ctaTimer = setTimeout(function () {
          if ($(this).scrollTop() >= scrollHeightTop) {
            $("#arrow-cta").addClass("show");
          } else {
            $("#arrow-cta").removeClass("show");
          }
        }, 50);
      }
    });
  }
  var controller = new ScrollMagic.Controller();
  if ($(".zoom-magic").length) {
    $(".zoom-magic").each(function (k, v) {
      let tween = TweenMax.fromTo(
        $(this),
        0.3,
        {
          scale: 1
        },
        {
          scale: 1.2,
          ease: Linear.easeNone
        }
      );
      let scene = new ScrollMagic.Scene({
        triggerElement: this,
        duration: 1000
      })
        .setTween(tween)
        .offset("-300")
        .addTo(controller);
    });
  }
  if ($(".hero-zoom").length) {
    let tween = TweenMax.fromTo(
      $(".hero-zoom"),
      0.3,
      {
        scale: 1
      },
      {
        scale: 1.2,
        ease: Linear.easeNone
      }
    );
    let scene = new ScrollMagic.Scene({
      triggerElement: ".hero-zoom",
      duration: 1500
    })
      .setTween(tween)
      .addTo(controller);
  }





  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  // Ajax MailChimp 
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

  if ($("#mailchimpform").length) {
    $("#mailchimpform").on("submit", function (event) {
      event.preventDefault();
      $("#mailchimpform .message")
        .removeClass("alert alert-danger alert-success")
        .text("");
      register($("#mailchimpform"));
      return false;
    });
  }
  var register = function ($form) {
    $.ajax({
      type: $form.attr("method"),
      url: $form.attr("action"),
      data: $form.serialize(),
      cache: false,
      dataType: "jsonp",
      jsonp: "c", // trigger MailChimp to return a JSONP response
      contentType: "application/json; charset=utf-8",
      error: function (err) {
        console.error(
          "Could not connect to the registration server. Please try again later."
        );
      },
      success: function (data) {
        if (data.result == "success") {
          $("#mailchimpform .message")
            .addClass("alert alert-success")
            .text("Thank you for Signing Up");
        } else {
          if (data.result == "error") {
            $("#mailchimpform .message")
              .addClass("alert alert-danger")
              .text("Sorry, you already subscribed to our newsletter.");
          } else {
            $("#mailchimpform .message")
              .addClass("alert alert-danger")
              .text(
                "Sorry, there's a problem sending your request. Please try again."
              );
          }
        }
      }
    });
  };

  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  // Init Seasonal
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

  if ($("#seasonal-section").length) {
    var $navbarToggler = $("#main-nav .navbar-toggler");
    var $logoW = $("#main-nav .alt-menu img.default");
    var $logo = $("#main-nav .alt-menu img").not(".default");
    var $elms = $("#background-scroll .chevron-hero");
    $logoW.addClass("d-none");
    $logo.removeClass("d-none");
    $navbarToggler
      .addClass("set-white")
      .removeClass("d-none")
      .removeClass("menu-color");
    new fullpage("#seasonal-section", {
      sectionSelector: ".vertical-scrolling",
      navigation: true,
      navigationPosition: "right",
      slidesNavigation: false,
      autoScrolling: false,
      controlArrows: true,
      scrollingSpeed: 800,
      touchSensitivity: 10,
      scrollOverflow: true,
      licenseKey: "7D643BE9-3ED54E96-9D5014D8-1831DEDE",
      afterRender: function () {
        $("#background-scroll .chevron-hero")
          .first()
          .addClass("active");
        fullpage_api.silentMoveTo(1);
        fullpage_api.setAutoScrolling(true);
      },
      onLeave: function (origin, destination, direction) {
        let $fpNav = $("#fp-nav");
        $elms.removeClass("active");
        $elms.eq(destination.index).addClass("active");
        if ($elms.length == destination.index) {
          // Last Section
          $("#main-nav").addClass("d-none");
          $fpNav.addClass("d-none");
        } else {
          $("#main-nav").removeClass("d-none");
          $fpNav.removeClass("d-none");
        }
      }
    });
    $(window).on("load", function () {
      setTimeout(function () {
        window.scrollTo(0, 0);
      }, 1);
    });
  }


});
$(window).on("load", function () {
  if ($(".grecaptcha-badge").length && $("form.wpcf7-form").length) {
    $(".grecaptcha-badge").css({
      visibility: "visible"
    });
  }
});



